import { ExportOutlined } from '@ant-design/icons';
import axios from 'axios';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GET_PRESIGNED_URL } from '../../services';
import CustomButton from '../Button';
import customTost from '../Notification';

const ExportQuery = (props) => {
	const {
		indexValue,
		indexAlias,
		aliasFlag,
		filters,
		observedAtDetail,
		selectedBucket,
		queryStack,
	} = useSelector((store) => store.storeProps);
	const bucketName = selectedBucket?.bucketName ? selectedBucket.bucketName : '';
	const metaInfo = selectedBucket?.metaInfo ? selectedBucket.metaInfo : '';
	const { enableExport, finalQuery } = props;
	const [fileUrl, setFileUrl] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		try {
			if (fileUrl) {
				downloadFile();
			}
		} catch (error) {
			console.error(error);
		}
	}, [fileUrl]);

	const downloadFile = () => {
		try {
			setIsLoading(false);
			const downloadQueryBtn = document.getElementById('downloadQuery');
			if (downloadQueryBtn) {
				downloadQueryBtn.click();
			}
		} catch (error) {
			console.error(error);
		}
	};

	const getPreSingedUrl = async (fileName) => {
		try {
			if (fileName) {
				const { data } = await GET_PRESIGNED_URL({
					fileName,
					bucketName: selectedBucket.bucketName,
				});
				if (data && data.statusCode === 200) {
					setFileUrl(data.url);
				}
			}
		} catch (error) {
			console.error(error);
			setIsLoading(false);
			customTost({
				type: 'error',
				message: 'Something went wrong. Please try later.',
			});
		}
	};

	const handleExport = () => {
		try {
			if (queryStack && observedAtDetail && filters) {
				setIsLoading(true);
				const queryData = {
					index: indexValue,
					alias: aliasFlag ? indexAlias : '',
					groups: filters ? filters : '',
					date: observedAtDetail && observedAtDetail.dateRange ? observedAtDetail.dateRange : '',
					bucketName: bucketName,
					metaInfo: metaInfo,
					bucketFolderName: selectedBucket?.bucketFolderName ? selectedBucket.bucketFolderName : '',
				};
				axios
					.post('/api/export-query', queryData)
					.then((res) => {
						if (res?.data?.signedUrl) {
							setFileUrl(res.data.signedUrl);
						} else {
							if (res?.data?.fileName) {
								getPreSingedUrl(res.data.fileName);
							}
						}
						if (res?.data?.statusCode === 400) {
							setIsLoading(false);
							customTost({
								type: 'error',
								message: res.data.message
									? res.data.message
									: 'Something went wrong. Please try later.',
							});
						}
					})
					.catch((error) => {
						setIsLoading(false);
						customTost({
							type: 'error',
							message: 'Something went wrong. Please try later.',
						});
						console.error(error);
					});
			}
		} catch (error) {
			setIsLoading(false);
			console.error(error);
		}
	};

	const isValidUrl = (url) => {
		try {
			const parsedUrl = new URL(url);
			// Allow only HTTP and HTTPS protocols
			return ['http:', 'https:'].includes(parsedUrl.protocol);
		} catch (error) {
			return false;
		}
	};

	const sanitizedFileUrl = isValidUrl(fileUrl) ? fileUrl : '';

	return (
		<>
			<CustomButton
				id='exportQueryButton'
				isLoading={isLoading}
				isDisabled={finalQuery ? (enableExport ? false : true) : true}
				icon={<ExportOutlined />}
				onClick={handleExport}
			>
				Export Query
			</CustomButton>

			<a
				href={DOMPurify.sanitize(sanitizedFileUrl)}
				id='downloadQuery'
				style={{ display: 'none' }}
				download='KLitequery'
			>
				Download
			</a>
		</>
	);
};

ExportQuery.propTypes = {
	finalQuery: PropTypes.string,
	enableExport: PropTypes.bool,
};

export default ExportQuery;
